<template>
  <div>
    <vs-card class="cardx">

      <div slot="header" style="padding:10px;height: 100%;width:100%;display:flex;align-items: center;">
        <feather-icon @click="$router.go(-1)" icon="ArrowLeftIcon"  class="cursor-pointer navbar-fuzzy-search mr-4" />
        <h3>
          {{title}}
        </h3>
      </div>

      <div>
        <vs-row >
          <vs-col  vs-lg="12" vs-sm="6" vs-xs="12" style="padding:10px">
            <h3>
                Log del día : {{this.formLogs.created_at}}
            </h3> 
          </vs-col>
          <vs-col  vs-lg="12" vs-sm="6" vs-xs="12" style="padding:10px">
            <a style="color:skyblue" href="/admin/drivers/list">drivers / </a>
            <a style="color:skyblue" :href="'/admin/drivers/driversLogs/'+this.$route.params.id" >{{this.form.firstname}} / </a>
            <a style="color:skyblue" href="#">logs / </a>
            <a style="color:skyblue" href="#">{{this.formLogs.created_at}}</a>
          </vs-col>
        </vs-row>  
      </div>

      <div >
        <vs-row>
          <vs-col vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-row>
                <vs-col vs-lg="12" vs-sm="6" vs-xs="12" style="padding:10px">
                    <label style="font-size: 20px">Location: <label> <a :href="`https://maps.google.com/?q=${this.formLogs.latitude},${this.formLogs.longitude}&z=18&t=k`" target="_blank" rel="nofollow">{{this.formLogs.latitude}}, {{this.formLogs.longitude}}</a></label></label>
                </vs-col>
            </vs-row>
            <vs-row>
                <vs-col vs-lg="12" vs-sm="6" vs-xs="12" style="padding:10px">
                    <label style="font-size: 20px">Type: <label>{{this.formLogs.type}}</label></label>
                </vs-col>
            </vs-row>
            <vs-row>
                <vs-col vs-lg="12" vs-sm="6" vs-xs="12" style="padding:10px">
                    <label style="font-size: 20px">Code Version : <label>{{this.formLogs.code_version}}</label></label>
                </vs-col>
            </vs-row>
            <vs-row>
                <vs-col vs-lg="12" vs-sm="6" vs-xs="12" style="padding:10px">
                    <label class="vs-input--label">Input data</label>
                </vs-col>
                <vs-col vs-lg="12" vs-sm="6" vs-xs="12" style="padding:10px; paddingTop:0;">
                    <div style="padding:10px;height:500px;width:100%;display:flex;backgroundColor:grey;overflow-y: scroll;">
                        <pre class="vs-input--label" style="color:white;">{{ this.payload }}</pre>
                    </div>
                </vs-col>
            </vs-row>
          </vs-col>

          <vs-col vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-row>
                <vs-col vs-lg="12" vs-sm="6" vs-xs="12" style="padding:10px">
                    <label style="font-size: 20px">Device: <label>{{this.formLogs.model_device}}</label></label>
                </vs-col>
            </vs-row>
            <vs-row>
                <vs-col vs-lg="12" vs-sm="6" vs-xs="12" style="padding:10px">
                    <label style="font-size: 20px">Ip: <label>{{this.formLogs.ip_address}}</label></label>
                </vs-col>
            </vs-row>
            <vs-row>
                <vs-col vs-lg="12" vs-sm="6" vs-xs="12" style="padding:10px">
                    <label style="font-size: 20px">App Version : <label>{{this.formLogs.app_version}}</label></label>
                </vs-col>
            </vs-row>
            <vs-row>
                <vs-col vs-lg="12" vs-sm="6" vs-xs="12" style="padding:10px">
                    <label class="vs-input--label">Service response</label>
                </vs-col>
                <vs-col vs-lg="12" vs-sm="6" vs-xs="12" style="padding:10px; paddingTop:0;">
                    <div style="padding:10px;height:500px;width:100%;display:flex;backgroundColor:grey;overflow-y: scroll;">
                         <pre class="vs-input--label" style="color:white;">{{ this.response }}</pre>
                    </div>
                </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </div> 

    </vs-card>
  </div>

</template>
<style itemscope>
  .img-inputer {
    width: 150px;
    height: 150px;
  }
</style>
<script>
  import {mapState, mapActions, mapGetters} from 'vuex';
  import ImgInputer from 'vue-img-inputer';
    import moment from 'moment'
    import Datepicker from 'vuejs-datepicker';

  export default {
    name :'DriverLogsDetails',
    components: {
      ImgInputer,
      Datepicker,
    },
    data(){
      return {
        expleJson: {
    "glossary": {
        "title": "example glossary",
		"GlossDiv": {
            "title": "S",
			"GlossList": {
                "GlossEntry": {
                    "ID": "SGML",
					"SortAs": "SGML",
					"GlossTerm": "Standard Generalized Markup Language",
					"Acronym": "SGML",
					"Abbrev": "ISO 8879:1986",
					"GlossDef": {
                        "para": "A meta-markup language, used to create markup languages such as DocBook.",
						"GlossSeeAlso": ["GML", "XML"]
                    },
					"GlossSee": "markup"
                }
            }
        }
    }
},
        page:0,
        fetching : true,
        title : null,
        filters:{
          zone_id: 'test'
        },
        response: null,
        payload: null,
        form:{
          partner_id : null,
          firstname: null,
          lastname: null,
          username: null,
          password: null,
          driver_license: null,
          type_license: null,
          phone: null,
          city: null,
          is_active:true
        },
        formLogs:{
          app_version: null,
          code_version: null,
          created_at: null,
          model_device: null,
          driver_id: null,
          id_log: null,
          ip_address: null,
          latitude: null,
          longitude: null,
          message: null,
          payload: null,
          response: null,
          type: null,
        },
        onSubmit : false,
        image : null,
        imgBase64 : null,

        data_timeline : [],
        showCrop: false,
        dates : {
        page: 0,
        since: moment().subtract(1,'weeks').toDate(),
        until: moment().toDate()        
        },
      }
    },
    computed : {
      ...mapState('partners',['partners']), 
      ...mapGetters('users',['userCan']),
      ...mapState('drivers',['drivers','currentPage']),
      since(){
        return moment(this.dates.since).format('YYYY-MM-DD');
      },
      until(){
        return moment(this.dates.until).format('YYYY-MM-DD');
      },
    },
    watch :{
      '$route.params.id': function (id) {
        this.initData();
      }
    },
    created() {
      this.initData();
    },
    methods: {
      ...mapActions('drivers',['getDriversLogsDetails','getDriver','storeDriver','updateDriver','fetchDrivers','deleteDriver','fetchDrivesReport','MassLoadDrivers','CheckDriverProgress']),
      ...mapActions('partners',['fetchPartners']),
      initData(){
        if(this.$route.params.id){
          this.title = 'Drivers Logs';
          this.getDriver({id: this.$route.params.id})
            .then(data=>{
                console.log('this.$route.params.id', this.$route.query.idlog)
              this.form = data;
              this.form.partner_id = data.partner ? data.partner.id : null;
              this.fetching = false;
              if(this.form.image){
                setTimeout(()=>{
                  this.$refs.cropper.replace(this.form.image);
                },300);
              }
              this.fetchDriversLogsDetails()
            })
            .catch(error=>{
              console.log(error)
              if(error){
                if(error.status === 404){
                  //this.$router.push({name: 'page-error-404'});
                }
              }
            })
        }else{
          this.title = 'Drivers Logs';
          this.fetching = false;
          this.form = {
            partner_id : this.partner_namespace,
            firstname: null,
            lastname: null,
            username: null,
            password: null,
            driver_license: null,
            type_license: null,
            phone: null,
            city: null,
            is_active:true
          };
        }
      },
      async submit(){
        let result = await this.$validator.validateAll();
        if (!result || this.onSubmit) {
          return;
        }
        this.$vs.loading({
          type:'point',
        });
        this.onSubmit = true;

        if(this.$route.params.id){
          if(!this.userCan('drivers.update')){
            this.$vs.notify({
              color: 'danger',
              title: `Error`,
              text: 'You need permission to perform this action',
            });
            return;
          }

          let form = _.cloneDeep(this.form);
          delete form.partner;
          if(!this.imageBase64){
            delete form.image
          }else{
            form.image = this.imageBase64;
          }

          this.updateDriver(form)
            .then(data=>{
              this.$vs.loading.close();
              this.onSubmit = false;
              this.msgDialog('success','Success','Driver successfully updated',this.redirectToDrivers);
            })
            .catch(error =>{
              this.$vs.loading.close();
              this.onSubmit = false;
              if(error){
                if(error.status === 409 || error.status === 400){
                  this.setErrors(error.data.errors);
                }else{
                    this.$vs.notify({
                      color: 'danger',
                      title: `Error`,
                      text: "There was an error. Please try again later.",
                    });
                }
              }
            })
        }else{
          if(!this.userCan('drivers.create')){
            this.$vs.notify({
              color: 'danger',
              title: `Error`,
              text: 'You need permission to perform this action',
            });
            return;
          }

          let form = _.cloneDeep(this.form);
          if(this.imageBase64){
            form.image = this.imageBase64;
          }
          this.storeDriver(form)
            .then(data=>{
              this.$vs.loading.close();
              this.onSubmit = false;
              this.msgDialog('success','Success','Driver successfully created',this.redirectToDrivers);
            })
            .catch(error =>{
              this.$vs.loading.close();
              this.onSubmit = false;
              if(error){
                if(error.status === 409 || error.status === 400){
                  this.setErrors(error.data.errors);
                }else{
                    this.$vs.notify({
                      color: 'danger',
                      title: `Error`,
                      text: "There was an error. Please try again later.",
                    });
                }
              }
            })
        }
      },
      msgDialog(color, title, text, action){
        this.$vs.dialog({
          color: color,
          title: title,
          text: text,
          accept:action
        })
      },
      redirectToPartners(){
        this.$router.push({name: 'partners.list'});
      },
      fileChange(file,filename){
        let reader = new FileReader()
        reader.readAsDataURL(this.image)
        reader.onload = (event)=> {
          this.imageBase64 = reader.result.split(',').pop();
          //this.showCrop = true;
        //   setTimeout(()=>{
        //     this.$refs.cropper.replace(reader.result);
        //   },300);
        };
      },
      updateDateQuery(){
        console.log('update query')

        this.page = 1;
        this.filters = {
          ...this.filters,
          page: '1',
          since: this.since,
          until : this.until,
        }
      },
      fetchDriversLogsDetails(){
        this.getDriversLogsDetails({id: this.$route.params.id, params: this.$route.query.idlog})
          .then(data=>{
              console.log('data', data)
              this.response = JSON.parse(data.response)
              this.payload = data.payload
              this.formLogs = data
          })
          .catch(error=>{
            console.log(error)
            if(error){
              if(error.status === 404){
                //this.$router.push({name: 'page-error-404'});
              }
            }
          })
      },
      setErrors(errors){
        for(let key in errors){
          if(Array.isArray(errors[key])){
            this.errors.add({
              field: key,
              msg: errors[key][0]
            });
          }
        }
      },

    },

  }
</script>